import React from 'react';
import { Grid, Header, Button, Icon, Segment, Label, List } from 'semantic-ui-react';
import { FilePreviewLink } from './FilePreviewLink';
import { FacturaBloqueada, facturaBloqueada } from './FacturaBloqueada';
import { getDisplayFileName } from '../../utils/fileUtils';

export const FileUploadSection = React.memo(({
  title,
  files,
  fileInputRef,
  onUploadClick,
  onFileChange,
  onDeleteFile,
  isAddMode = false,
  multiple = false,
  accept = "'image/jpg','image/jpeg', 'image/png', 'image/bmp', 'application/*'",
  showFileList = true,
  bloqueado = false,
  bloqueadoPor = ''
}) => {
  /*
  La factura la cargó otro usuario y no se tiene permiso para abrirla: se informa
  quién la cargó y no se permite ni verla, ni borrarla, ni reemplazarla.
  `bloqueado` lo pasa la página cuando el archivo viene como string (facturación Lizen);
  si viene como objeto del backend (factura a cliente) se detecta solo.
  */
  const estaBloqueada = bloqueado || facturaBloqueada(files);
  const cargadoPor = bloqueadoPor || (files && files.created_by_nombre) || '';

  if (estaBloqueada) {
    return (
      <>
        <Segment color='blue'><strong>{title}</strong></Segment>
        <Segment>
          <FacturaBloqueada cargadoPor={cargadoPor} />
        </Segment>
      </>
    );
  }

  const renderFileList = () => {
    if (!showFileList || !files) return null;

    // Caso: array de strings (modo add con legajos)
    if (Array.isArray(files) && files.length > 0 && typeof files[0] === 'string') {
      return (
        <Segment>
          <p>Archivo(s) seleccionado(s)</p>
          <Label.Detail>
            <List>
              {files.map((file, i) => (
                <List.Item key={i}>
                  <FilePreviewLink filePath={file}>
                    {getDisplayFileName(file)}
                  </FilePreviewLink>
                  <Button
                    compact={true}
                    icon
                    basic
                    type="button"
                    target="_blank"
                    circular
                    size='mini'
                    onClick={() => onDeleteFile(file)}
                  >
                    <Icon name="delete" color='red'/>
                  </Button>
                </List.Item>
              ))}
            </List>
          </Label.Detail>
        </Segment>
      );
    }

    // Caso: array de objetos (modo edit con legajos)
    if (Array.isArray(files) && files.length > 0 && files[0]?.file_legajo) {
      return (
        <Segment>
          <p>Archivo(s) seleccionado(s)</p>
          <Label.Detail>
            <List>
              {files.map((file) => (
                <List.Item key={file.id}>
                  <FilePreviewLink filePath={file.file_legajo}>
                    {getDisplayFileName(file.file_legajo)}
                  </FilePreviewLink>
                  <Button
                    compact={true}
                    icon
                    basic
                    type="button"
                    target="_blank"
                    circular
                    size='mini'
                    onClick={() => onDeleteFile(file.id)}
                  >
                    <Icon name="delete" color='red'/>
                  </Button>
                </List.Item>
              ))}
            </List>
          </Label.Detail>
        </Segment>
      );
    }

    // Caso: string único (factura)
    if (typeof files === 'string' && files !== null) {
      return (
        <Segment>
          <p>Archivo seleccionado</p>
          <Label.Detail>
            <FilePreviewLink filePath={files}>
              {getDisplayFileName(files)}
            </FilePreviewLink>
            <Button
              compact={true}
              icon
              basic
              target="_blank"
              circular
              size='mini'
              onClick={() => onDeleteFile(files)}
            >
              <Icon name="delete" color='red'/>
            </Button>
          </Label.Detail>
        </Segment>
      );
    }

    // Caso: objeto con url_archivo (factura cliente)
    if (files && typeof files === 'object' && files.url_archivo) {
      return (
        <Segment>
          <p>Archivo seleccionado</p>
          <Label.Detail>
            <FilePreviewLink filePath={files.url_archivo}>
              {getDisplayFileName(files.url_archivo)}
            </FilePreviewLink>
            <Button
              type="button"
              compact={true}
              icon
              basic
              target="_blank"
              circular
              size='mini'
              onClick={() => onDeleteFile(files)}
            >
              <Icon name="delete" color='red'/>
            </Button>
          </Label.Detail>
        </Segment>
      );
    }

    return null;
  };

  return (
    <>
      <Segment color='blue'><strong>{title}</strong></Segment>
      {renderFileList()}
      <Grid>
        <Grid.Row>
          <Grid.Column computer={16} mobile={16} tablet={16}>
            <label className='dropzone'>
              <Header icon disabled>
                <Icon name='upload' circular/>
              </Header>
              <Button
                type="button"
                variant="contained"
                color="primary"
                component="span"
                icon
                onClick={onUploadClick}
              >
                {multiple ? 'Agregar documento(s)' : 'Agregar documento'}
              </Button>
            </label>
            <input
              className="input"
              accept={accept}
              id="ButtonProductUpFile"
              type="file"
              onChange={onFileChange}
              style={{display: 'none'}}
              ref={fileInputRef}
              multiple={multiple}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
});

